import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { SanctionEntity } from 'app/entities/monitoring/actual/sanction-matches.model';
import { EntityMonitoringService } from 'app/entities/monitoring/entity-monitoring.service';

/**
 * Ad-hoc Beamar sanction search from the header search ("Instant screening").
 */
@Component({
  selector: 'app-instant-screening-dialog',
  templateUrl: './instant-screening-dialog.component.html',
  styleUrls: ['./instant-screening-dialog.component.css']
})
export class InstantScreeningDialogComponent {
  /** Initial name from the header search field (may be edited before Run). */
  screenName = '';
  screeningType: 'PERSON' | 'ORGANIZATION' = 'PERSON';

  results: SanctionEntity[] = [];
  errorMessage = '';
  loading = false;
  hasRun = false;

  constructor(
    public dialogRef: MdDialogRef<InstantScreeningDialogComponent>,
    private entityMonitoringService: EntityMonitoringService
  ) {}

  runScreening() {
    const name = (this.screenName || '').trim();
    if (!name) {
      this.errorMessage = 'Enter a name to screen.';
      return;
    }
    this.loading = true;
    this.hasRun = true;
    this.errorMessage = '';
    this.results = [];
    this.entityMonitoringService.instantScreening(name, this.screeningType).subscribe(
      response => {
        this.loading = false;
        const arrResult = response && response.arrResult;
        const msg = response && response.message;
        if (msg && (!Array.isArray(arrResult) || arrResult.length === 0)) {
          this.errorMessage = msg;
        } else if (Array.isArray(arrResult)) {
          this.results = arrResult;
        } else {
          this.results = [];
        }
      },
      err => {
        this.loading = false;
        this.errorMessage = err.message || 'Screening request failed';
      }
    );
  }

  get hasError(): boolean {
    return !!this.errorMessage;
  }

  get hasResults(): boolean {
    return !this.hasError && this.results && this.results.length > 0;
  }

  get noResults(): boolean {
    return this.hasRun && !this.loading && !this.hasError && this.results && this.results.length === 0;
  }

  getDisplayName(se: SanctionEntity): string {
    return se.globalName || [se.firstName, se.middleName, se.lastName].filter(Boolean).join(' ') || '-';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/instant-screening-dialog/instant-screening-dialog.component.ts